module.exports = __webpack_public_path__ + "img/book.2c1d6ac9.png";